<template>
    <form @submit.prevent="$emit('onEvent', data)">
        <app-model :class="{ 'show': show }" size="model-sm">
            <template v-slot:header class="modal-header d-flex align-items-center">
                <h4 class="card-title mb-0">Eliminar registro</h4>
                <button type="button" @click="onClose()" class="btn-close"></button>
            </template>
            <template v-slot:body class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group text-center mb-3">
                            <p>¿Realmente desea eliminar estos registros?<br> Este proceso no se puede deshacer.</p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer class="modal-footer d-flex justify-content-center">
                <button type="submit" class="btn btn-danger text-white rounded-pill px-4">
                    <span v-if="submit" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span :class="{ 'visually-hidden': submit }">
                        <i class="ti ti-device-floppy me-1 fs-4"></i> Eliminar
                    </span>
                </button>
                <button type="button" @click="onClose()"
                    class="btn btn-dark rounded-pill px-4 ms-2 text-white">Cancelar</button>
            </template>
        </app-model>
    </form>
</template>
<script>
export default {
  props: {
    id: {
      type: String | Number,
      default: null
    },
    submit: {
      type: Boolean,
      default: false
    },
    onEvent: {
      type: Function,
      default: () => { console.log('aca') }
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    setInterval(() => {
      if (this.id) {
        this.show = true
      }
    }, 100)
  },
  methods: {
    onClose: function () {
      this.show = false
      this.$emit('onClose')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/models/Delete.vue